import * as types from '../types'

const init = {
    isBai: true,
    btUrl: 'https://bt.jd.com/v3/mobile/rGuide_initGuideMobile?channelName=103002682933',
    rewardUrl: 'https://m.jr.jd.com/member/mc/',
    moneyUrl: 'https://mxxq.jd.com/mx/home?from=223bttgqd&pageId=2894'
}

const base = (state = init, action) => {
    switch (action.type) {
        case types.HANDLE_ISBAI: {
            const isBai = action.data;
                return {
                    ...state,
                    isBai,
                }
        }

        default:
            return state
    }
}

export default base
